import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { CoreModule, LazyloadService } from '@dm/core';

import { ConfigPolicyModule } from './config-policy/config-policy.module';
import { ConfigPolicySModule } from './config-policy/config-policy-s/config-policy-s.module';
import { ConfirmModule } from './confirm/confirm.module';
import { CreateComponent } from './create.component';
import { CreateStrService } from './create-str.service';
import { SpecifyObjModule } from './specify-obj/specify-obj.module';

@NgModule({
    declarations: [CreateComponent],
    imports: [
        CommonModule,
        CoreModule,
        ConfigPolicyModule,
        ConfirmModule,
        SpecifyObjModule,
        FormsModule,
        ReactiveFormsModule,
        ConfigPolicySModule,
    ],
    providers: [CreateStrService, LazyloadService],
})
export class CreateModule { }
